import { defineSlotRecipe } from '@chakra-ui/react';
import { switchAnatomy } from '@chakra-ui/react/anatomy';

import { switchThumbScale, switchTrackHeight, switchTrackWidth } from './switch.kds';

const switchSizeStyles = (size: keyof typeof switchTrackWidth) => ({
  root: {
    '--switch-width': switchTrackWidth[size],
    '--switch-height': switchTrackHeight[size],
    // Size axis owns thumb scale; solid.thumb reads this var (direct thumb.scale loses to Chakra's merged solid default).
    '--switch-thumb-scale': switchThumbScale[size],
  },
});

/** KDS Switch overrides — Chakra defaults handle structure/animation (node 20:664). */
export const switchSlotRecipe = defineSlotRecipe({
  slots: switchAnatomy.keys(),
  base: {
    root: {
      gap: '8px',
    },
    label: {
      textStyle: 'default.regular',
      _disabled: {
        color: 'neutral.350',
        opacity: 0.8,
      },
    },
  },
  variants: {
    variant: {
      solid: {
        control: {
          bg: 'neutral.250',
          _checked: {
            bg: 'brand.500',
          },
          _disabled: {
            bg: 'neutral.250',
            opacity: 0.6,
            _checked: {
              bg: 'brand.500',
            },
          },
        },
        thumb: {
          bg: 'neutral.50',
          borderRadius: 'full',
          boxShadow: 'none',
          width: 'var(--switch-height)',
          height: 'var(--switch-height)',
          scale: 'var(--switch-thumb-scale)',
          _checked: {
            bg: 'neutral.50',
          },
          _disabled: {
            bg: 'neutral.200',
            _checked: {
              bg: 'neutral.200',
            },
          },
        },
      },
    },
    size: {
      sm: switchSizeStyles('sm'),
      md: switchSizeStyles('md'),
      lg: switchSizeStyles('lg'),
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'solid',
  },
});
